import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const testimonials = [{
  quote: 'Organicé toda mi planificación de entrenamiento en un fin de semana. Ahora sé exactamente qué hacer cada día para sacar el Front Lever. Nunca más entreno improvisando a ver qué sale.',
  author: 'Tomás M.',
  location: 'Buenos Aires',
  role: 'Atleta de Calistenia en casa'
}, {
  quote: 'Las progresiones técnicas cambiaron todo. Logré mi primer Muscle Up estricto en 2 meses después de estar un año entero estancado. Y sin dolores de hombro.',
  author: 'Ignacio R.',
  location: 'Rosario',
  role: 'Practicante de Street Workout'
}, {
  quote: 'Adapto la intensidad de la rutina según cómo me siento ese día en 5 minutos. Antes me llevaba horas buscar videos en YouTube para armar algo coherente.',
  author: 'Valentina F.',
  location: 'Córdoba',
  role: 'Entrena Calistenia con anillas en casa'
}];
export function TestimonialsStrip() {
  return <section className="py-8 md:py-12 bg-brand-card border-y border-brand-border" data-id="element-355">
      <div className="container mx-auto px-4" data-id="element-356">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-357">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} className="flex flex-col" data-id="element-358">
              <div className="flex gap-1 mb-4" data-id="element-359">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-brand-orange text-brand-orange" data-id="element-360" />)}
              </div>
              <p className="text-brand-muted italic mb-6 flex-grow" data-id="element-361">
                "{t.quote}"
              </p>
              <div data-id="element-362">
                <p className="font-bold text-brand-text" data-id="element-363">{t.author}</p>
                <p className="text-xs text-brand-muted" data-id="element-364">
                  {t.location} — {t.role}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}